export default __webpack_public_path__ + "static/media/section2_1.c18b2fa3.webp";